import { createComponent } from '@mtfe/sweet';
import { eventBus, dom, common } from '@mtfe/sweet-utils';
import { ErrorPage } from '@mtfe/sweet-components';

import store, { storeRecallBizIdMap } from '../../store';
import tpl from './dom.html';
import style from './style.less';
import EveryDayComponent from '../../components/EveryDayComponent/script';
import RedBagComponent from '../../components/RedBagComponent/script';
import SelfCouponComponent from '../../components/SelfCouponComponent/script';
import { ERROR_TEXT } from '../../constants';

const { storeCommon } = store;
const { createUniqueId } = common;
const wmDomId = createUniqueId();

const WelfareWaimaiModuleReady = (welfareArr) => {
    eventBus.$onceOn('WelfareWaimaiModuleReady', async () => {
        const { structInfo } = storeCommon;
        const {
            dom_wm_red_bag: domWmRedBag,
            dom_wm_every_day_coupon: domWmEveryDayCoupon,
        } = structInfo.struct;
        const storeWmRedBag = store[domWmRedBag.recallBizId];
        const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
        const storeWmSelfCoupon = store[storeRecallBizIdMap.wmSelfCoupon];

        if (storeWmRedBag.isShow) {
            const readyKey = 'Waimai';
            eventBus.$emit(`${readyKey}RedBagComponentReady`);
        }
        if (storeWmEveryDayCoupon.isShow) {
            eventBus.$emit('EveryDayComponentReady');
        }
        try {
            await SelfCouponComponent(welfareArr);
            if (
                !storeWmSelfCoupon.isShow &&
                !storeWmRedBag.isShow &&
                !storeWmEveryDayCoupon.isShow
            ) {
                const wmIndexBodyDom = dom.$id(wmDomId);
                if (wmIndexBodyDom) {
                    wmIndexBodyDom.innerHTML = ErrorPage({ text: ERROR_TEXT });
                }
            }
        } catch (error) {
            console.error(error);
        }
    });
};
const WelfareWaimaiModule = () => {
    const { structInfo } = storeCommon;
    const {
        dom_wm_red_bag: domWmRedBag,
        dom_wm_every_day_coupon: domWmEveryDayCoupon,
    } = structInfo.struct;
    const storeWmRedBag = store[domWmRedBag.recallBizId];
    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];

    const welfareArr = [];

    if (storeWmRedBag.isShow && storeWmEveryDayCoupon.isShow) {
        const redBagDom = RedBagComponent({
            targetStore: storeWmRedBag,
            welfareIndex: '福利1',
            couponKey: 'Waimai',
        });
        const everyDayDom = EveryDayComponent('福利2');
        welfareArr.push(redBagDom, everyDayDom);
    } else if (storeWmRedBag.isShow && !storeWmEveryDayCoupon.isShow) {
        const redBagDom = RedBagComponent({
            targetStore: storeWmRedBag,
            welfareIndex: '福利1',
            couponKey: 'Waimai',
        });
        welfareArr.push(redBagDom);
    } else if (!storeWmRedBag.isShow && storeWmEveryDayCoupon.isShow) {
        const everyDayDom = EveryDayComponent('福利1');
        welfareArr.push(everyDayDom);
    }
    const data = {
        welfareArr,
        wmDomId,
    };
    const events = {};
    WelfareWaimaiModuleReady(welfareArr);
    return createComponent(tpl, { data, style }, events);
};

export default WelfareWaimaiModule;
